import { BidV2Status, type EvaluationDto } from "../../../../autogen/bff-api";

export const everyScoreIn = (evaluation: EvaluationDto | null | undefined): boolean => {
  if (evaluation == null) return false;
  const rankable = evaluation.bids.filter((bid) => bid.status !== BidV2Status.Rejected);
  return (
    rankable.length > 0 &&
    evaluation.progress.filled >= evaluation.progress.total
  );
};
